import { render, staticRenderFns } from "./join-class-list-page.html?vue&type=template&id=4d503203&"
import script from "./join-class-list-page.ts?vue&type=script&lang=ts&"
export * from "./join-class-list-page.ts?vue&type=script&lang=ts&"
import style0 from "./join-class-list-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports